import i18next from 'i18next';

export const getDefaultSchema = () => ({
  type: 'object',
  title: i18next.t('uploadHash:title'),
  properties: {
    name: {
      type: 'string',
      title: i18next.t('uploadHash:name')
    },
    description: {
      type: 'string',
      title: i18next.t('uploadHash:description')
    },
    hash: {
      type: 'array',
      title: i18next.t('uploadHash:listOfHashes'),
      items: {
        title: 'Hash',
        type: 'string',
        format: 'hash'
      }
    }
  },
  required: ['name', 'hash']
});

export const defaultUISchema = {
  hash: {
    items: {
      'ui:field': 'HashField'
    }
  },
  'ui:order': ['name', 'description', 'hash', '*']
};

export const customFormats = {
  'hash': /\b[A-Fa-f0-9]{64}\b/
};
